import React from 'react';

import { Icon } from '../icons';

export const PdfIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 25 32" fill={color} style={style}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.6187 6.1238L18.375 0.881078C17.8125 0.318688 17.05 0 16.2563 0H3.5C1.84375 0.00624878 0.5 1.34974 0.5 3.00566V29.0006C0.5 30.6565 1.84375 32 3.5 32H21.5C23.1562 32 24.5 30.6565 24.5 29.0006V8.24839C24.5 7.45479 24.1812 6.68619 23.6187 6.1238ZM21.2563 8.00469H16.5V3.24937L21.2563 8.00469ZM3.5 3.00566V29.0006H21.5V11.0041H15C14.1687 11.0041 13.5 10.3355 13.5 9.50439V3.00566H3.5Z"
      />
    </svg>
  );
};
